var map = {
	"./pr-1.png": "3ec6",
	"./pr-10.png": "b8cf",
	"./pr-11.png": "84a8",
	"./pr-12.png": "4df4e",
	"./pr-13.png": "a16d",
	"./pr-2.png": "d22b",
	"./pr-3.png": "872e",
	"./pr-4.png": "267f",
	"./pr-5.png": "799b6",
	"./pr-6.png": "dbc0",
	"./pr-7.png": "d3f5",
	"./pr-8.png": "e2da",
	"./pr-9.png": "d716"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3dd3";